import { CLEAR_STATE, SET_STATE } from '@/store/mutation-types'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  mutations: {
    [SET_STATE]: (state, items) => {
      state.items = items
    },
    [CLEAR_STATE]: state => {
      state.items = []
    },
  },
}
